import { render, staticRenderFns } from "./OrderSales.vue?vue&type=template&id=6909ec7e"
import script from "./OrderSales.vue?vue&type=script&lang=js"
export * from "./OrderSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports